export default defineNuxtRouteMiddleware((to, from) => {
  if (to.name === "current-offers") {
    return navigateTo("/campaigns/see-homes/", { redirectCode: 302 });
  }
});
